 export class personalData{
   personalDetail: personalDetails;
   nationalityDtos:nationalityDetails;
 }
 
 
 export class personalDetails{
   cellPhone:string ='';
   email: string ='';
   titleId: number = null;
   title: string ='';
   firstName:  string ='';
   middleName?: string ='';
   lastName:  string ='';
   dateOfBirth: any ='';
   fatherName:  string ='';
   religionCode: number = null;
   countryOfBirth: number = null;
   domicileDistrictId: number = null;
   name: string ='';
   genderCode: number = null;
   maritalStatusCode: number = null;
   fatherCnic:  string ='';
   fatherStatus:  string ='';
   fatherCurrentlyEmployed: boolean = false;
   cnic:  string ='';
   fullName:  string ='';
   age: number = null;
   cityId: number = null;
   cityName: string ='';
   districtId: number = null;
   districtName: string ='';
   domicileDistrict: string ='';
   husbandName: string ='';
   fatherStatusId:number = null;
   fatherJobFieldId: number = null;  
   profileId: number = 0;
   ageStr:string = '';
   countryId?:number = null;
   birthDate?:any;
 }
 

 export class addressDetails{
       id: number = null;
       addressTypeCode: number = null;
       address: string  ='';
       cityNamedomicileId: number = null;
       provinceId: number = null;
       zipCode: string  ='';
       postalCodeId: number = null;
       activeIndicator: boolean;
       countryId: number = null;
       cityId: number = null;
       domicileId: number = null;
       addressType?: number = null;
       cityName?:string = '';
       domicileName?:string = '';
       provinceName?:string = '';
       countryName?:string ='';
       postalCodeValue?:string = '';
       
 }
 
 export class nationalityDetails {
   id?:number = null;
   countryId: number = null;
   countryName?:string = ''
   identityTypeCode: number = null;
   identityNo: string;
   primary: boolean;
   creationTime?:any;
   activeIndicator:boolean;
 }